// extracted by mini-css-extract-plugin
module.exports = {"plexBalance":"PlexBalance_plexBalance__2g__u","icon":"PlexBalance_icon__1Pivl","text":"PlexBalance_text__dl3Hy"};